import { GetRankByIdResponse } from '@/modules/manage-rank/type'
import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { RankQueryKeys } from '@/modules/manage-rank/keys'
import { getRankById } from '../../services'

export default function useQueryGetRankById(
	id: string,
	props?: UseBaseQueryOptions<GetRankByIdResponse>,
) {
	return useQuery({
		queryKey: [RankQueryKeys.GetRankById, id],
		queryFn: () => getRankById(id),
		...props,
	})
}
